import { render, staticRenderFns } from "./SearchBox3.vue?vue&type=template&id=a2d5ee7c&scoped=true&"
import script from "./SearchBox3.vue?vue&type=script&lang=js&"
export * from "./SearchBox3.vue?vue&type=script&lang=js&"
import style0 from "./SearchBox3.vue?vue&type=style&index=0&id=a2d5ee7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d5ee7c",
  null
  
)

export default component.exports